import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import { InfoAlert } from './InfoAlert';

interface MemoProps {
  readonly content: Readonly<{
    auto?: string | null;
    internal?: string | null;
    memo?: string | null;
  }>;
  readonly display: Readonly<{
    auto?: boolean;
    internal?: boolean;
    memo?: boolean;
  }>;
}

export const Memo = ({ content, display }: Readonly<MemoProps>) => (
  <Stack spacing={2}>
    {!!display.auto && (
      <Alert
        icon={<PrecisionManufacturingIcon />}
        severity="success"
        sx={{ whiteSpace: 'pre-line' }}
      >
        <AlertTitle>Mémo automatique</AlertTitle>
        {/*eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing*/}
        {content.auto || 'Aucune information'}
      </Alert>
    )}
    {!!display.internal && (
      <Alert severity="warning" sx={{ whiteSpace: 'pre-line' }}>
        <AlertTitle>Mémo interne</AlertTitle>
        {/*eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing*/}
        {content.internal || 'Aucune information'}
      </Alert>
    )}
    {!!display.memo && (
      <InfoAlert sx={{ whiteSpace: 'pre-line' }}>
        <AlertTitle>Mémo</AlertTitle>
        {/*eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing*/}
        {content.memo || 'Aucune information'}
      </InfoAlert>
    )}
  </Stack>
);
